module.exports = __webpack_public_path__ + "static/training-data-7ba241fac4effa7210213bd70e5f9bcf.png";